(function () {
    pagination(true);
})();

// We are using observer for this
const jumpTop = document.querySelector('.jump-top');
const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting === false) {
        jumpTop.classList.add('show');
    } else {
        jumpTop.classList.remove('show');
    }
});
// Show the Jump to top selector only when the user scrolls down 20px from the top of the document
observer.observe(document.querySelector('footer'));

